import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { BalanceService } from '../balance/balance.service';
import { config } from '../../shared/config';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * This points transfer service will handle transferring points from
 * the current member to a target member. Each method will handle transfers
 * for different purses.
 */
@Injectable({
  providedIn: 'root',
})
export class PointsTransferService {
  constructor(private api: ApiService, private balanceService: BalanceService) {}

  /**
   * Calls the points transfer endpoint to transfer by external ref 
   * @param amount  The amount to be transferred to the target member
   * @param toExternalRef External ref number of the target user
   */
  pointsTransfer(amount: number, toExternalRef: string): Observable<any> {
    return this.api.post('points/' + toExternalRef + '/transfer/' + amount, null).pipe(
      tap((x) => {
        this.balanceService.debitBalance(config.purseConfig.virtualLoyalty, amount);
      })
    );
  }

  /**
   * Calls the points transfer endpoint to transfer by MemberId
   * @param amount  The amount to be transferred to the target member
   * @param toMemberId MemberId of the target user
   */
  pointsTransferToMemberID(amount: number, toMemberId: string): Observable<any> {
    return this.api.post('points/' + toMemberId + '/transferByMemberId/' + amount, null).pipe(
      tap((x) => {
        this.balanceService.debitBalance(config.purseConfig.virtualLoyalty, amount);
      })
    );
  }

  /**
   * @param fromMemberId  The current member
   * @param toMemberId  The target member
   * @param amount  The amount to be transferred to the target member
   * @returns This method handles a post request to the required endpoint responsible
   * for transferring the renewal bonus purse balance from one member to another. It must be passed the source MemberId
   * (member to transfer balance from), target MemberId (member to transfer balance to),
   * and amountToTransfer (how much to be transferred in pence).
   */
  renewalBonusTransfer(fromMemberId: string, toMemberId: string, amount: number): Observable<any> {
    return this.api.post(
      `bonuscredit/transferrenewalbonus?sourceMemberId=${fromMemberId}&targetMemberId=${toMemberId}&amountToTransfer=${amount}`,
      null
    );
  }

  /**
   * @param fromMemberId  The current member
   * @param toMemberId  The target member
   * @param amount  The amount to be transferred to the target member
   * @returns This method handles a post request to the required endpoint responsible
   * for transferring the balance from one member to another. It must be passed the source MemberId
   * (member to transfer balance from), target MemberId (member to transfer balance to),
   * and amountToTransfer (how much to be transferred in pence).
   */
  transferBalance(fromMemberId: string, toMemberId: string, amount: number): Observable<any> {
    return this.api.post(
      `bonuscredit/transferbalance?sourceMemberId=${fromMemberId}&targetMemberId=${toMemberId}&amountToTransfer=${amount}`,
      null
    );
  }

}
